import api from "./api";
import { API_URL_VERSION } from "constants/environment";
import { toSearchFilter } from "utils";

export const ENDPOINT_AGENTS = API_URL_VERSION + "agentes"
export const ENDPOINT_AGENTS_LIST = ENDPOINT_AGENTS + "/listar"
export const ENDPOINT_AGENTS_GET_HISTORY = ENDPOINT_AGENTS + "/historico"

export const agentsService = {
    list: async (params) => {
        try {
            const response = await api.post(ENDPOINT_AGENTS_LIST, toSearchFilter(params));
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.agent.messages.errors.list";
        }
    },

    create: async (data) => {
        try {
            const response = await api.post(ENDPOINT_AGENTS, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "settings.agent.messages.errors.create";
        }
    },

    find: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_AGENTS}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.agent.messages.errors.find";
        }
    },

    findHistory: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_AGENTS_GET_HISTORY}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.agent.messages.errors.find-agent-history";
        }
    },

    update: async (id, data) => {
        try {
            const response = await api.put(`${ENDPOINT_AGENTS}/${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "settings.agent.messages.errors.update";
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`${ENDPOINT_AGENTS}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.agent.messages.errors.delete";
        }
    },

    lookup: async () => {
        try {
            const response = await api.get(ENDPOINT_AGENTS_LIST);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.agent.messages.errors.list";
        }
    },

};
